<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "chevron-double-down" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 24 24'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <path
        d = 'M7 13L12 18L17 13M7 6L12 11L17 6'
        stroke-width = '1.5'
        stroke-linecap = 'round'
        stroke-linejoin = 'round'
        vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
    </path>
</svg>